import { TextToSpeech } from './text2speech.ts';

export {
  TextToSpeech
}
